<template>
  <el-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    center
    :class="classes"
    :width="width"
    @open="whenOpen"
  >
    <template v-if="showTitle" slot="title">
      <slot name="title" v-bind="bindProps">{{ computedTitle }}</slot>
    </template>
    <div class="tg-modal--content">
      <div v-show="showIcon" :class="iconClass"></div>
      <!-- 避免切到單字 -->
      <p v-show="showSubject" style="word-break: break-word; text-align:center;">
        <slot name="subject" v-bind="bindProps">
          <template v-html="subject">{{ subject }}</template>
        </slot>
      </p>
      <p v-show="showSubtitle">
        <slot name="subtitle" v-bind="bindProps">
          <template v-html="subtitle">{{ subtitle }}</template>
        </slot>
      </p>
      <slot>
        <span v-show="showNote" v-html="note">{{ note }}</span>
      </slot>
    </div>
    <template slot="footer" v-if="isShowFooter">
      <slot name="footer" v-bind="bindProps">
        <el-row type="flex" justify="space-around">
          <button
            type="button"
            class="cancel"
            v-if="showCancelBtn"
            @click="cancel"
            
          >
            {{ cancelText }}
          </button>
          <button type="button" :class="confirmBtnClasses" @click="confirm" :disabled="disableConfirmBtn == 1">
            {{ confirmText }}
          </button>
        </el-row>
      </slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default() {
        return "45%";
      },
    },
    theme: String,
    title: String,
    subject: String,
    subtitle: String,
    note: String,
    data: Object,
    showIcon: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showTitle: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showFooter: Boolean,
    showCloseBtn: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showCancelBtn: Boolean,
    confirmLabel: String,
    cancelLabel: String,
    autoResize: Boolean,
    disableConfirmBtn:Boolean,
    confirmBtnClass:Array
  },
  computed: {
    defTitle() {
      return this.$t("component.dialog.title");
    },
    computedTitle() {
      return this.title ? this.title : this.defTitle;
    },
    confirmText() {
      return this.confirmLabel || this.$t("component.btn.confirm");
    },
    cancelText() {
      return this.cancelLabel || this.$t("component.btn.cancel");
    },
    currentTheme() {
      return this.theme
        ? this.theme
        : this.item && this.item.status === 1
        ? "warning"
        : "info";
    },
    themeCls() {
      return this.currentTheme;
    },
    classes() {
      return [
        "tg-modal",
        this.themeCls,
        {
          "no-footer": !this.isShowFooter,
        },
      ];
    },
    iconClass() {
      return ["tg-modal-icon", this.themeCls];
    },
    bindProps() {
      return {
        title: this.title,
        subject: this.subject,
        subtitle: this.subtitle,
        note: this.note,
      };
    },
    isShowFooter() {
      return this.showFooter || this.showCancelBtn;
    },
    showSubject() {
      return (
        !!this.subject ||
        !!this.$slots["subject"] ||
        !!this.$scopedSlots["subject"]
      );
    },
    showSubtitle() {
      return (
        this.subtitle ||
        this.$slots["subtitle"] ||
        this.$scopedSlots["subtitle"]
      );
    },
    showNote() {
      return !!this.note;
    },
    confirmBtnClasses(){
      if(this.confirmBtnClass){
        return this.confirmBtnClass;
      }else{
        if(this.disableConfirmBtn == 1){
          return ['disabled'];
        }else{
          return ['confirm'];
        }
      }
    }
  },
  mounted() {
    // this.handleResize();
  },
  methods: {
    handleResize() {
      let dialog = this.$el.querySelector(".el-dialog");
      let body = dialog.querySelector(".el-dialog__body");

      if (!body) {
        return;
      }

      let content = body.querySelector(".tg-modal--content");
      let children = content.children;
      let width = 0;
      let height = content.clientHeight;

      if (children.length > 0) {
        for (let item of children) {
          let w = item.clientWidth;
          if (w > width) {
            width = w;
          }
        }
      }

      if (width < height) {
        width = height;
      }

      if (width > 0) {
        this.width = width + 82 + "px";
      }
    },
    whenOpen() {
      this.$emit("opened");
      this.$nextTick(() => {
        if (this.autoResize) {
          this.handleResize();
        }
      });
    },
    close() {
      this.$refs.dialog.hide();
    },
    cancel() {
      let e = {};
      this.$emit("on-cancel", e);
      if (!e.preventDefault) {
        this.close();
      }
    },
    confirm() {
      let e = {};
      this.$emit("on-confirm", e);
      if (!e.preventDefault) {
        this.close();
      }
    },
  },
};
</script>
